var React = require('react');
var Constants = require('../../constants/Constants');
var DropdownButton = require('react-bootstrap').DropdownButton;
var Link = require('react-router').Link;
var MenuItem = require('react-bootstrap').MenuItem;
var MenuItemLink = require('react-router-bootstrap').MenuItemLink;
var Nav = require('react-bootstrap').Nav;
var Router = require('react-router');

var ClientStore = require('../../stores/ClientStore');
var Config = require('../../config/Config');
var Image = require('../Image');
var Loading = require('../Loading');
var ServiceActions = require('../../actions/ServiceActions');
var UserStore = require('../../stores/UserStore');

var logoHiRes = require('../../images/infinite-logo-web-hi-res.png');

function getState() {
    return {
        availableClients: UserStore.getAvailableClients(),
        client: ClientStore.get(),
        user: UserStore.getUser()
    }
}

var Header = React.createClass({
    contextTypes: {
        router: React.PropTypes.func
    },
    propTypes: {
        isAuthenticated: React.PropTypes.bool.isRequired,
        name: React.PropTypes.string.isRequired
    },
    componentWillMount: function () {
        ClientStore.addChangeListener(this.update);
        UserStore.addChangeListener(this.update);

        if (this.state.user && (!this.state.client || !this.state.client.name)) {
            ServiceActions.getServices();
        }
    },
    componentWillUnmount: function () {
        ClientStore.removeChangeListener(this.update);
        UserStore.removeChangeListener(this.update);
    },
    getInitialState: function () {
        return getState();
    },
    getHeader: function () {
        return <div className="navbar-header">
            <Link className="navbar-brand" to="dashboard">
                <Image desktopSrc={logoHiRes} mobileSrc={logoHiRes} title={this.props.name} />
            </Link>
        </div>;
    },
    getMenus: function () {
        return [
            // this.getLeftMenu(),
            this.getRightMenu()
        ];
    },
    getRightMenu: function () {
        if (!this.props.isAuthenticated) {
            return null;
        }

        var username = this.state.user ?
            (this.state.user.first_name + ' ' + this.state.user.last_name) :
            <Loading />;
        var email = this.state.user ?
            this.state.user.email : '';
        var client = this.state.client && this.state.client.name ?
            this.state.client.name :
            <Loading />;
        var accountLink = this.state.user ?
            <MenuItem href={Config.ssoProfileUrl}>Manage Account</MenuItem> :
            null;
        var dropdownTitle = <span title={email}><span className="thin-hide">{username} for </span>{client}</span>;
        var switchLinks;
        if (this.state.availableClients.length) {
            switchLinks = this.state.availableClients.filter(function (availableClient) {
                return !this.state.client || availableClient.id !== this.state.client.id;
            }.bind(this)).map(function (client, key) {
                var switchClient = function () {
                    UserStore.setActiveClientId(client.id);

                    if (this.context.router.getCurrentPathname() === '/auth') {
                      this.context.router.transitionTo('auth', null, this.context.router.getCurrentQuery());
                    } else {
                      this.context.router.transitionTo('dashboard');
                    }
                }.bind(this);

                return <MenuItem key={key} onSelect={switchClient}>
                    Switch to {client.name}
                </MenuItem>;
            }.bind(this));
        }

        return <Nav right pullRight key="right" ulClassName="navbar-nav pull-right">
            <DropdownButton title={dropdownTitle}>
                {accountLink}
                {switchLinks}
                <MenuItemLink to="logout">Logout</MenuItemLink>
            </DropdownButton>
        </Nav>;
    },
    render: function () {
        var menus = this.getMenus();
        var header = this.getHeader();

        return <nav className="navbar navbar-default orbmm" role="navigation">
            {header}
            <div>
                {menus}
            </div>
        </nav>;
    },
    update: function () {
        this.setState(getState());
    }
})
module.exports = Header;



// WEBPACK FOOTER //
// ./app/components/Layout/Header.js